import React from 'react';
import styled from 'styled-components';
//
import Subscribe from 'components/subscribe';
//
export default ({ ...rest }) => (
  <Wrap>
    <Subscribe {...rest} />
  </Wrap>
);
//
const Wrap = styled.div``;
